import * as moment from "moment";
import { roleTypeGroup, roleTypeSap } from "src/_constants/roleType";
import { Role } from "src/_models/user";

export function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export const sportIdMap: { [key: string]: string } = {
  cricket: "4",
  tennis: "2",
  football: "1",
};

// Upoch must be in Milliseconds
export const ConvertUpochToDate = (date: number) => {
  return moment.unix(date / 1000).format("DD MMM YYYY hh:mm A");
};

export const IsSAPAdmin = () => {
  let userInfo = JSON.parse(sessionStorage.getItem("currentUser"));
  return roleTypeSap.includes(userInfo.role) ? true : false;
};

export const IsGAAdmin = () => {
  let userInfo = JSON.parse(sessionStorage.getItem("currentUser"));
  return roleTypeGroup.includes(userInfo.role) ? true : false;
};

/**
 * Format numbers with Indian-style grouping (e.g. 1,000 and 2,35,978) and fixed decimals.
 */
export function formatIndianNumber(value: any, fractionDigits: number = 2): string {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  const n = Number(value);
  if (Number.isNaN(n)) {
    return "-";
  }
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(n);
}

// A bet-limit profile section leaves min/max at 0 to mean "keep the operator's
// own stake limits", while delay (ms) and odd limits apply on their own
// whenever they are above 0. These two keep every screen describing a section
// the same way.
export const LimitStakesLabel = (section: any): string => {
  const min = (section && Number(section.min)) || 0;
  const max = (section && Number(section.max)) || 0;
  if (min > 0 || max > 0) {
    return min + " – " + max;
  }
  return LimitExtrasLabel(section) ? "Operator stakes" : "Operator default";
};

export const LimitExtrasLabel = (section: any): string => {
  const delay = (section && Number(section.delay)) || 0;
  const oddLimits = (section && Number(section.oddLimits)) || 0;
  const extras = [];
  if (delay > 0) {
    extras.push(delay + "ms delay");
  }
  if (oddLimits > 0) {
    extras.push("odds ≤ " + oddLimits);
  }
  return extras.join(" · ");
};
